/* The Hollow Harvest · il carrello (G8, 21 ott 2026). Markup in sections/main-cart-items.liquid e
   sections/main-cart-footer.liquid, stili in assets/hhr-carrello.css.

   1. Lo scambio con la saga completa. Il bottone del foglietto ([data-hhr-scambia]) aggiunge B (data-b,
      id della variante) e poi, in una sola chiamata a /cart/update.js, porta a zero le voci che B
      sostituisce (data-via: chiavi di riga separate da "|", cioe' A e i DLC da soli). Se la seconda
      chiamata fallisce, toglie B e il carrello torna com'era: non resta mai un carrello con A e B insieme
      per colpa nostra. Le due sezioni si ridisegnano come le ridisegna cart.js di Dawn (stesse sezioni,
      stessi selettori), poi si avvisa il resto della pagina con cartUpdate (source 'cart-items', cosi'
      cart-items non rifa' la richiesta). Il fuoco va sul titolo della voce nuova, che prende per un attimo
      la tinta del frumento; il lettore di schermo sente data-fatto.
   2. La barra fissa del telefono ([data-hhr-qbarra], sotto i 750 px): sale quando "Check-out" (#checkout)
      e' fuori schermo, sta giu' quando e' sullo schermo, quando il carrello e' vuoto e quando il banner dei
      cookie di Shopify e' aperto (non lo copre mai). Il totale lo copia da data-hhr-tot ogni volta che
      cart.js ridisegna il piede. Mentre la barra e' armata, html.hhr-qbarra lascia in fondo alla pagina lo
      spazio della barra, cosi' non copre mai le ultime righe.
   3. L'arrivo dalla pagina prodotto: l'intestazione del sito (hh-header) non ha la notifica di Dawn, quindi
      "Aggiungi al carrello" porta qui. La riga appena aggiunta prende il timbro "Appena aggiunto"
      (template[data-hhr-timbro] in main-cart-items) e la tinta del frumento.
   Il bottone della barra e' uguale al principale (submit, name=checkout, form=cart): stesso consenso
   (assets/hh-recesso.js), stesso pagamento.
   ES5 come il resto del sito; senza JavaScript la barra resta nascosta e lo scambio non c'e' (il bottone
   non fa niente, il carrello resta quello). */
(function () {
  'use strict';
  if (window.hhrCarrello) return;
  window.hhrCarrello = true;
  var d = document, html = d.documentElement;
  var R = window.routes || {};
  var ADD = (R.cart_add_url || '/cart/add') + '.js';
  var UPD = (R.cart_update_url || '/cart/update') + '.js';
  var CHG = (R.cart_change_url || '/cart/change') + '.js';

  function clarity(nome) {
    try { if (typeof window.clarity === 'function') window.clarity('event', nome); } catch (e) { }
  }
  function fermo() {
    try { return window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { return false; }
  }
  function posta(url, corpo) {
    return window.fetch(url, {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(corpo)
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok || (j && j.status && j.status >= 400)) throw j || new Error(String(r.status));
        return j;
      });
    });
  }

  /* --------------------------------------------------------------- lo scambio -- */
  /* ridisegna come cart.js: stesse sezioni, stessi selettori */
  function dipingi(ci, sezioni, stato) {
    if (!stato || !stato.sections) return;
    var vuoto = stato.item_count === 0;
    ci.classList.toggle('is-empty', vuoto);
    var piede = d.getElementById('main-cart-footer');
    if (piede) piede.classList.toggle('is-empty', vuoto);
    sezioni.forEach(function (s) {
      var el = d.getElementById(s.id), sorgente = stato.sections[s.section];
      if (!el || !sorgente) return;
      var dove = el.querySelector(s.selector) || el;
      try { dove.innerHTML = ci.getSectionInnerHTML(sorgente, s.selector); } catch (e) { }
    });
    if (typeof window.hhrEntrate === 'function') {
      try { window.hhrEntrate(ci); if (piede) window.hhrEntrate(piede); } catch (e) { }
    }
    try {
      if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
        publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cart-items', cartData: stato });
      }
    } catch (e) { }
  }

  function annuncia(testo) {
    var r = d.getElementById('cart-live-region-text');
    if (!r || !testo) return;
    r.textContent = testo;
    r.setAttribute('aria-hidden', 'false');
    setTimeout(function () { r.setAttribute('aria-hidden', 'true'); }, 4000);
  }

  function mostraNuova(chiave) {
    if (!chiave) return;
    var voci = d.querySelectorAll('.hhr-r[data-hhr-chiave]'), riga = null;
    for (var i = 0; i < voci.length; i++) if (voci[i].getAttribute('data-hhr-chiave') === chiave) riga = voci[i];
    if (!riga) return;
    riga.classList.add('is-nuova');
    setTimeout(function () { riga.classList.remove('is-nuova'); }, 2200);
    var r = riga.getBoundingClientRect();
    if (r.top < 0 || r.top > (window.innerHeight || 0) * 0.7) {
      try { riga.scrollIntoView({ block: 'center', behavior: fermo() ? 'auto' : 'smooth' }); } catch (e) { riga.scrollIntoView(); }
    }
    var nome = riga.querySelector('.cart-item__name');
    if (nome) { try { nome.focus({ preventScroll: true }); } catch (e) { nome.focus(); } }
  }

  function scambia(b) {
    var ci = d.querySelector('cart-items');
    if (!ci || typeof ci.getSectionsToRender !== 'function' || !window.fetch || !window.Promise) return;
    var idB = parseInt(b.getAttribute('data-b'), 10);
    var via = (b.getAttribute('data-via') || '').split('|').filter(function (k) { return k; });
    if (!idB || !via.length) return;
    var carta = b.closest('[data-hhr-scambio]');
    var err = carta ? carta.querySelector('[data-hhr-scambio-err]') : null;
    var msgErr = err ? err.textContent : '';
    var fatto = b.getAttribute('data-fatto') || '';
    var testo = b.textContent;
    b.setAttribute('aria-busy', 'true');
    b.disabled = true;
    b.textContent = b.getAttribute('data-attesa') || testo;
    if (err) err.hidden = true;
    var lista = d.getElementById('main-cart-items');
    if (lista) lista.classList.add('cart__items--disabled');

    var sezioni = ci.getSectionsToRender();
    var nomi = sezioni.map(function (s) { return s.section; });
    var chiaveB = null;

    function libera() {
      if (lista) lista.classList.remove('cart__items--disabled');
      if (b.isConnected !== false) {
        b.removeAttribute('aria-busy');
        b.disabled = false;
        b.textContent = testo;
      }
    }
    function sbaglio() {
      var e2 = d.querySelector('[data-hhr-scambio-err]');
      if (e2) { e2.hidden = false; return; }
      annuncia(msgErr);
    }

    posta(ADD, { items: [{ id: idB, quantity: 1 }] })
      .then(function (r) {
        chiaveB = r && r.items && r.items[0] ? r.items[0].key : null;
        var su = {};
        via.forEach(function (k) { su[k] = 0; });
        return posta(UPD, { updates: su, sections: nomi, sections_url: window.location.pathname });
      })
      .then(function (stato) {
        libera();
        dipingi(ci, sezioni, stato);
        annuncia(fatto);
        mostraNuova(chiaveB);
        clarity('carrello_scambio');
      })
      .catch(function () {
        clarity('carrello_scambio_errore');
        /* B non e' entrato: si guarda il carrello vero, e se B c'e' comunque si ricarica la pagina */
        if (!chiaveB) {
          window.fetch((R.cart_url || '/cart') + '.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' })
            .then(function (r) { return r.json(); })
            .then(function (c) {
              var dentro = (c.items || []).some(function (it) { return it.variant_id === idB; });
              if (dentro) { window.location.reload(); return; }
              libera(); sbaglio();
            }, function () { libera(); sbaglio(); });
          return;
        }
        /* B e' entrato ma il resto no: si toglie B, il carrello torna com'era */
        posta(CHG, { id: chiaveB, quantity: 0, sections: nomi, sections_url: window.location.pathname })
          .then(function (stato) { libera(); dipingi(ci, sezioni, stato); sbaglio(); },
            /* anche questo non va: il carrello a schermo non e' piu' quello vero, si ricarica la pagina */
            function () { window.location.reload(); });
      });
  }

  d.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-hhr-scambia]') : null;
    if (!b || b.getAttribute('aria-busy') === 'true') return;
    e.preventDefault();
    scambia(b);
  });

  /* ---------------------------------------------------------------- la barra -- */
  function barra() {
    var bar = d.querySelector('[data-hhr-qbarra]');
    var btn = d.getElementById('checkout');
    var piede = d.getElementById('main-cart-footer');
    if (!bar || !btn || !piede || !('IntersectionObserver' in window) || !window.matchMedia) return;
    var mq = window.matchMedia('(max-width: 749px)');
    var tot = bar.querySelector('[data-hhr-qbarra-tot]');
    var visto = true, banner = false, coda = 0;
    bar.hidden = false;

    function bannerAperto() {
      var el = d.getElementById('shopify-pc__banner');
      if (!el) return false;
      var r = el.getBoundingClientRect();
      if (r.width < 1 || r.height < 1 || r.top >= (window.innerHeight || 0)) return false;
      var cs = window.getComputedStyle(el);
      return cs.display !== 'none' && cs.visibility !== 'hidden' && parseFloat(cs.opacity || '1') > 0.05;
    }
    function aggiorna() {
      coda = 0;
      banner = bannerAperto();
      var armata = mq.matches && !piede.classList.contains('is-empty');
      var su = armata && !visto && !banner;
      bar.classList.toggle('is-su', su);
      html.classList.toggle('hhr-qbarra', armata);
      if (armata) html.style.setProperty('--hhr-barra-h', bar.offsetHeight + 'px');
    }
    function presto() {
      if (coda) return;
      coda = (window.requestAnimationFrame || setTimeout)(aggiorna);
    }
    function copiaTotale() {
      var t = piede.querySelector('[data-hhr-tot]');
      if (t && tot) tot.textContent = t.getAttribute('data-hhr-tot');
    }

    new IntersectionObserver(function (voci) {
      voci.forEach(function (v) { visto = v.isIntersecting; });
      aggiorna();
    }).observe(btn);

    if (window.MutationObserver) {
      var conti = piede.querySelector('.js-contents');
      if (conti) new MutationObserver(copiaTotale).observe(conti, { childList: true, subtree: true });
      new MutationObserver(presto).observe(piede, { attributes: true, attributeFilter: ['class'] });
      /* il banner dei cookie arriva tardi e cambia stato da solo */
      new MutationObserver(presto).observe(d.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['style', 'class', 'hidden', 'aria-hidden'] });
    }
    window.addEventListener('click', function () { setTimeout(presto, 350); }, true);
    window.addEventListener('resize', presto);
    if (mq.addEventListener) mq.addEventListener('change', presto); else if (mq.addListener) mq.addListener(presto);
    copiaTotale();
    aggiorna();
  }

  /* ------------------------------------------------------ appena aggiunto -- */
  /* assets/product-form.js, prima di portare qui, lascia in sessionStorage la chiave della riga aggiunta.
     Se il segnale e' fresco (meno di un minuto) la riga prende il timbro e la tinta, il lettore di schermo
     sente "Aggiunto al carrello: titolo". Il segnale si legge una volta sola. */
  function arrivo() {
    var s = null;
    try { s = JSON.parse(window.sessionStorage.getItem('hhr-aggiunto') || 'null'); window.sessionStorage.removeItem('hhr-aggiunto'); } catch (e) { return; }
    if (!s || !s.k || !s.t || Date.now() - s.t > 60000 || Date.now() < s.t) return;
    var voci = d.querySelectorAll('.hhr-r[data-hhr-chiave]'), riga = null;
    for (var i = 0; i < voci.length; i++) if (voci[i].getAttribute('data-hhr-chiave') === s.k) riga = voci[i];
    var modello = d.querySelector('template[data-hhr-timbro]');
    if (!riga || !modello) return;
    var corpo = riga.querySelector('.hhr-r__corpo');
    if (corpo && modello.content && !corpo.querySelector('.hhr-r__timbro')) {
      corpo.insertBefore(d.importNode(modello.content, true), corpo.firstChild);
    }
    var nome = riga.querySelector('.cart-item__name');
    annuncia((modello.getAttribute('data-annuncio') || '') + ' ' + (nome ? nome.textContent.trim() : ''));
    mostraNuova(s.k);
    clarity('carrello_arrivo');
  }

  function via() {
    try { arrivo(); } catch (e) { }
    try { barra(); } catch (e) { }
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', via); else via();
})();
